import { VenueBasedMembershipGroupSerializer } from "@app-contexts/dashboard/features/memberships/data/types/membership-groups";
import {
  UserMembershipGroupDetailSerializer,
  UserMembershipGroupLevelsSerializer,
  UserMembershipLevelMemberSerializer,
} from "@app-contexts/user/features/memberships/data/types";
import {
  PublicMembershipGroupSerializer,
  RenewalUserMembership,
} from "../types";

// Helper function to find seat information
export const findSeat = (
  level: UserMembershipGroupLevelsSerializer,
  member: UserMembershipLevelMemberSerializer,
  membershipGroupInfo?: UserMembershipGroupDetailSerializer
) =>
  membershipGroupInfo?.membership_levels
    ?.find((membership_level) => membership_level.id === level.id)
    ?.members.find((member_in_members) => member.id === member_in_members.id)
    ?.seat;

// Function to format member data
export const formatMember = (
  level: UserMembershipGroupLevelsSerializer,
  member: UserMembershipLevelMemberSerializer,
  membershipGroupInfo?: UserMembershipGroupDetailSerializer
): RenewalUserMembership => ({
  expiry_date: member.expiry_date ? new Date(member.expiry_date) : new Date(),
  id: member.id,
  membership_group: membershipGroupInfo?.id,
  membership_group_name: membershipGroupInfo?.name,
  membership_group_renewal_frequency: membershipGroupInfo?.renewal_frequency,
  membership_group_renewals_enabled: membershipGroupInfo?.renewals_enabled,
  membership_level: level.id,
  membership_level_name: level.name,
  seat: findSeat(level, member, membershipGroupInfo),
  status: member.status,
  user: member.user,
  username: member.username,
  venue: membershipGroupInfo?.venue.id,
});

export const isPublicMembershipGroup = (
  membershipGroup:
    | PublicMembershipGroupSerializer
    | VenueBasedMembershipGroupSerializer
): membershipGroup is PublicMembershipGroupSerializer => {
  return (
    membershipGroup &&
    "venue" in membershipGroup &&
    typeof membershipGroup.venue !== "number"
  );
};
